/**
 * Created by matheusmorett on 05/09/18.
 */
import PageLoader from './PageLoader';
export default PageLoader;
